var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgLike = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 20,
  height: 20,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  clipRule: "evenodd",
  d: "M9.994 4.28C8.328 2.332 5.55 1.808 3.462 3.592c-2.087 1.783-2.381 4.765-.742 6.875 1.363 1.754 5.488 5.453 6.84 6.65.151.134.227.201.315.228a.42.42 0 0 0 .239 0c.088-.027.163-.094.315-.228 1.351-1.197 5.476-4.896 6.84-6.65 1.639-2.11 1.38-5.11-.743-6.875-2.123-1.765-4.865-1.26-6.532.688Z",
  stroke: "#000",
  strokeWidth: 1.67,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})));
export default SvgLike;